import React, { useState, useEffect } from "react";
import { AutoComplete as AutoCompleteR } from "rsuite";

// this component include label, input text box
// required *, help/tip message, and error state with error message

// base on input props.isRequired, props.hasError
// update the className, to show error, and required

// use props.value to set phone number, need + at first char for country

// https://rsuitejs.com/components/auto-complete/



const AutoComplete = (props) => {
  //const [state, setState] = React.useState(null);
  const [newValue, setnewValue] = useState(null);
  

  const listStates = [
    "Massachusetts (MA)",
    "Alabama (AL)",
    "Alaska (AK)",
    "American Samoa (AS)",
    "Arizona (AZ)",
    "Arkansas (AR)",
    "California (CA)",
    "Colorado (CO)",
    "Connecticut (CT)",
    "Delaware (DE)",
    "District of Columbia (DC)",
    "Florida (FL)",
    "Georgia (GA)",
    "Guam (GU)",
    "Hawaii (HI)",
    "Idaho (ID)",
    "Illinois (IL)",
    "Indiana (IN)",
    "Iowa (IA)",
    "Kansas (KS)",
    "Kentucky (KY)",
    "Louisiana (LA)",
    "Maine (ME)",
    "Maryland (MD)",
    "Michigan (MI)",
    "Minnesota (MN)",
    "Mississippi (MS)",
    "Missouri (MO)",
    "Montana (MT)",
    "Nebraska (NE)",
    "Nevada (NV)",
    "New Hampshire (NH)",
    "New Jersey (NJ)",
    "New Mexico (NM)",
    "New York (NY)",
    "North Carolina (NC)",
    "North Dakota (ND)",
    "Northern Mariana Islands (MP)",
    "Ohio (OH)",
    "Oklahoma (OK)",
    "Oregon (OR)",
    "Pennsylvania (PA)",
    "Puerto Rico (PR)",
    "Rhode Island (RI)",
    "South Carolina (SC)",
    "South Dakota (SD)",
    "Tennessee (TN)",
    "Texas (TX)",
    "Utah (UT)",
    "Vermont (VT)",
    "Virginia (VA)",
    "Virgin Islands (VI)",
    "Washington (WA)",
    "West Virginia (WV)",
    "Wisconsin (WI)",
    "Wyoming (WY)"
  ];

  const listCountry = [
    "United States (US)",
    "Afghanistan (AF)",
    "Aland Islands (AX)",
    "Albania (AL)",
    "Algeria (DZ)",
    "American Samoa (AS)",
    "Andorra (AD)",
    "Angola (AO)",
    "Anguilla (AI)",
    "Antarctica (AQ)",
    "Antigua and Barbuda (AG)",
    "Argentina (AR)",
    "Armenia (AM)",
    "Aruba (AW)",
    "Australia (AU)",
    "Austria (AT)",
    "Azerbaijan (AZ)",
    "Bahamas (BS)",
    "Bahrain (BH)",
    "Bangladesh (BD)",
    "Barbados (BB)",
    "Belarus (BY)",
    "Belgium (BE)",
    "Belize (BZ)",
    "Benin (BJ)",
    "Bermuda (BM)",
    "Bhutan (BT)",
    "Bolivia (BO)",
    "Bonaire, Sint Eustatius and Saba (BQ)",
    "Bosnia and Herzegovina (BA)",
    "Botswana (BW)",
    "Bouvet Island (BV)",
    "Brazil (BR)",
    "British Indian Ocean Territory (IO)",
    "Brunei Darussalam (BN)",
    "Bulgaria (BG)",
    "Burkina Faso (BF)",
    "Burundi (BI)",
    "Cambodia (KH)",
    "Cameroon (CM)",
    "Canada (CA)",
    "Cape Verde (CV)",
    "Cayman Islands (KY)",
    "Central African Republic (CF)",
    "Chad (TD)",
    "Chile (CL)",
    "China (CN)",
    "Christmas Island (CX)",
    "Cocos (Keeling) Islands (CC)",
    "Colombia (CO)",
    "Comoros (KM)",
    "Congo (CG)",
    "Congo, Democratic Republic of the Congo (CD)",
    "Cook Islands (CK)",
    "Costa Rica (CR)",
    "Cote D'Ivoire (CI)",
    "Croatia (HR)",
    "Cuba (CU)",
    "Curacao (CW)",
    "Cyprus (CY)",
    "Czech Republic (CZ)",
    "Denmark (DK)",
    "Djibouti (DJ)",
    "Dominica (DM)",
    "Dominican Republic (DO)",
    "Ecuador (EC)",
    "Egypt (EG)",
    "El Salvador (SV)",
    "Equatorial Guinea (GQ)",
    "Eritrea (ER)",
    "Estonia (EE)",
    "Ethiopia (ET)",
    "Falkland Islands (Malvinas) (FK)",
    "Faroe Islands (FO)",
    "Fiji (FJ)",
    "Finland (FI)",
    "France (FR)",
    "French Guiana (GF)",
    "French Polynesia (PF)",
    "French Southern Territories (TF)",
    "Gabon (GA)",
    "Gambia (GM)",
    "Georgia (GE)",
    "Germany (DE)",
    "Ghana (GH)",
    "Gibraltar (GI)",
    "Greece (GR)",
    "Greenland (GL)",
    "Grenada (GD)",
    "Guadeloupe (GP)",
    "Guam (GU)",
    "Guatemala (GT)",
    "Guernsey (GG)",
    "Guinea (GN)",
    "Guinea-Bissau (GW)",
    "Guyana (GY)",
    "Haiti (HT)",
    "Heard Island and Mcdonald Islands (HM)",
    "Holy See (Vatican City State) (VA)",
    "Honduras (HN)",
    "Hong Kong (HK)",
    "Hungary (HU)",
    "Iceland (IS)",
    "India (IN)",
    "Indonesia (ID)",
    "Iran, Islamic Republic of (IR)",
    "Iraq (IQ)",
    "Ireland (IE)",
    "Isle of Man (IM)",
    "Israel (IL)",
    "Italy (IT)",
    "Jamaica (JM)",
    "Japan (JP)",
    "Jersey (JE)",
    "Jordan (JO)",
    "Kazakhstan (KZ)",
    "Kenya (KE)",
    "Kiribati (KI)",
    "Korea, Democratic People's Republic of (KP)",
    "Korea, Republic of (KR)",
    "Kosovo (XK)",
    "Kuwait (KW)",
    "Kyrgyzstan (KG)",
    "Lao People's Democratic Republic (LA)",
    "Latvia (LV)",
    "Lebanon (LB)",
    "Lesotho (LS)",
    "Liberia (LR)",
    "Libyan Arab Jamahiriya (LY)",
    "Liechtenstein (LI)",
    "Lithuania (LT)",
    "Luxembourg (LU)",
    "Macao (MO)",
    "Macedonia, the Former Yugoslav Republic of (MK)",
    "Madagascar (MG)",
    "Malawi (MW)",
    "Malaysia (MY)",
    "Maldives (MV)",
    "Mali (ML)",
    "Malta (MT)",
    "Marshall Islands (MH)",
    "Martinique (MQ)",
    "Mauritania (MR)",
    "Mauritius (MU)",
    "Mayotte (YT)",
    "Mexico (MX)",
    "Micronesia, Federated States of (FM)",
    "Moldova, Republic of (MD)",
    "Monaco (MC)",
    "Mongolia (MN)",
    "Montenegro (ME)",
    "Montserrat (MS)",
    "Morocco (MA)",
    "Mozambique (MZ)",
    "Myanmar (MM)",
    "Namibia (NA)",
    "Nauru (NR)",
    "Nepal (NP)",
    "Netherlands (NL)",
    "Netherlands Antilles (AN)",
    "New Caledonia (NC)",
    "New Zealand (NZ)",
    "Nicaragua (NI)",
    "Niger (NE)",
    "Nigeria (NG)",
    "Niue (NU)",
    "Norfolk Island (NF)",
    "Northern Mariana Islands (MP)",
    "Norway (NO)",
    "Oman (OM)",
    "Pakistan (PK)",
    "Palau (PW)",
    "Palestinian Territory, Occupied (PS)",
    "Panama (PA)",
    "Papua New Guinea (PG)",
    "Paraguay (PY)",
    "Peru (PE)",
    "Philippines (PH)",
    "Pitcairn (PN)",
    "Poland (PL)",
    "Portugal (PT)",
    "Puerto Rico (PR)",
    "Qatar (QA)",
    "Reunion (RE)",
    "Romania (RO)",
    "Russian Federation (RU)",
    "Rwanda (RW)",
    "Saint Barthelemy (BL)",
    "Saint Helena (SH)",
    "Saint Kitts and Nevis (KN)",
    "Saint Lucia (LC)",
    "Saint Martin (MF)",
    "Saint Pierre and Miquelon (PM)",
    "Saint Vincent and the Grenadines (VC)",
    "Samoa (WS)",
    "San Marino (SM)",
    "Sao Tome and Principe (ST)",
    "Saudi Arabia (SA)",
    "Senegal (SN)",
    "Serbia (RS)",
    "Serbia and Montenegro (CS)",
    "Seychelles (SC)",
    "Sierra Leone (SL)",
    "Singapore (SG)",
    "Sint Maarten (SX)",
    "Slovakia (SK)",
    "Slovenia (SI)",
    "Solomon Islands (SB)",
    "Somalia (SO)",
    "South Africa (ZA)",
    "South Georgia and the South Sandwich Islands (GS)",
    "South Sudan (SS)",
    "Spain (ES)",
    "Sri Lanka (LK)",
    "Sudan (SD)",
    "Suriname (SR)",
    "Svalbard and Jan Mayen (SJ)",
    "Swaziland (SZ)",
    "Sweden (SE)",
    "Switzerland (CH)",
    "Syrian Arab Republic (SY)",
    "Taiwan, Province of China (TW)",
    "Tajikistan (TJ)",
    "Tanzania, United Republic of (TZ)",
    "Thailand (TH)",
    "Timor-Leste (TL)",
    "Togo (TG)",
    "Tokelau (TK)",
    "Tonga (TO)",
    "Trinidad and Tobago (TT)",
    "Tunisia (TN)",
    "Turkey (TR)",
    "Turkmenistan (TM)",
    "Turks and Caicos Islands (TC)",
    "Tuvalu (TV)",
    "Uganda (UG)",
    "Ukraine (UA)",
    "United Arab Emirates (AE)",
    "United Kingdom (GB)",
    "United States Minor Outlying Islands (UM)",
    "Uruguay (UY)",
    "Uzbekistan (UZ)",
    "Vanuatu (VU)",
    "Venezuela (VE)",
    "Viet Nam (VN)",
    "Virgin Islands, British (VG)",
    "Virgin Islands, U.s. (VI)",
    "Wallis and Futuna (WF)",
    "Western Sahara (EH)",
    "Yemen (YE)",
    "Zambia (ZM)",
    "Zimbabwe (ZW)"
  ];
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    //console.log("run me then page is mounted/updated");
    //setDataList(getDataList(props.dataSet));
    getDataList();    
    //return () => console.log("you left! unmounting...");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // <-- empty array here make it only rnu once

  function getDataList() {
     // if dataSet is null or empty
    if( props.dataSet === undefined || props.dataSet === null || props.dataSet === "" ) {
      setDataList([]);
    } else {    // dataSet is state or country or url
	    switch (props.dataSet) {
	      case "state":
	        setDataList(listStates);
	        break;
	      case "country":
	        setDataList(listCountry);
	        break;
	      default:
	        // fetch data here
	        //console.log("url = ", props.dataSet);
	        fetch(props.dataSet)
	          .then((res) => res.json())
	          .then((result) => {
	            //console.log("json from URL data", str);
	            //console.log(result);
	            setDataList(result);
	          });
	        break;
	    }
    }
  }
  // default onChange handler
  function defaultOnChange(e) {
    // onChange is return value to formik
    //setValue(e);
    //console.log("in component onchange, e =", e);
    setnewValue(e);
    if (props.onChange !== undefined && props.onChange !== null) {
      props.onChange(e);
    } else {
      //console.log("no onChange function, value= " + e);
    }
  }

  function defaultOnBlur(e) {
    if (props.onBlur !== undefined && props.onBlur !== null) {
      props.onBlur(e);
    } else {
      //console.log("no OnBlur function, value= ", e);
    }
  }

  //function defaultOnFocus(e) {
   // if (props.onFocus !== undefined && props.onFocus !== null) {
   //   return true;
   // }
   // return false;
  //}

  return (
    <div className="statecountryinput__container">
      {/* display label */}
      <label
        className={`statecountryinput__label ${
          props.hasError ? "statecountryinput__label--error" : ""
        }
        ${props.isDisabled ? "statecountryinput__label--disabled" : ""}

        ${props.showFlag ? "" : "statecountryinput__hideFlag"}

        `}
      >
        {props.labelText}
        {/* display reqiored * */}
        <span
          className="statecountryinput__required"
          style={props.isRequired ? {} : { display: "none" }}
        >
          *
        </span>
        <AutoCompleteR
          data={dataList}
          //style={{ width: 300 }}
          //value={props.value}
          // user can enter new value, over write the props.value
          // on load, new value will be null, so take the props.value,
          // on user enter, new value can be empty or string, over write the props.value
          // onchange, update the value
          value={newValue !== null || newValue === "" ? newValue : props.value}
          onChange={(e) => defaultOnChange(e)}
          onBlur={(e) => defaultOnBlur(e.target.value)}
          disabled={props.isDisabled ? true : false}
          // className={`${props.hasError ? "inputbox__textbox--error" : ""}`}
          //onFocus={(e) => defaultOnFocus(e)} //cause select by key bug
        />
        {/* display help message */}
        <span className="statecountryinput__help">{props.helpMessage}</span>
        {/* display errorMessage or formik error message */}
        <span
          className="statecountryinput__error"
          style={props.hasError ? {} : { display: "none" }}
        >
          {props.errorMessage}
        </span>
      </label>
    </div>
  );
};

export default AutoComplete;
